import { apiService } from "./apiService";
import { endpoints } from "@/config/endpoints";
import { pickBy } from "lodash";
import Stream from "@/utils/stream";
const prepareRequestData = ({
  page,
  perPage,
  query,
  reply,
  rating,
  tags_search_type,
  tags_ids,
  comment,
  is_accurate,
  has_note,
  has_rb_review,
  has_customer_media,
  has_review_photos,
  has_review_videos,
  gmb_address_ids,
  cities,
  groups,
  date,
  only_ids = false,
  order_by,
  only_count,
  deleted,
  hidden,
  date_type,
  only_created,
  only_updated
}) => {
  const payload = {
    q: query,
    reply,
    rating,
    tags_handling: tags_search_type,
    tags: tags_ids,
    is_accurate,
    has_note,
    has_rb_review,
    has_customer_media,
    has_review_photos,
    has_review_videos,
    gmb_address_ids,
    cities,
    groups,
    date_from: date[0],
    date_to: date[1],
    order_by,
    deleted,
    hidden,
    date_type,
    only_created,
    only_updated
  };

  let params = {
    q: query,
    page: page || 1,
    page_size: perPage || 10,
    only_count
  };

  if (only_ids) {
    params = {
      ...(query && { q: query }),
      only_ids: true
    };
    payload.reply = "false";
    payload.is_processing = "false";
  }

  if (comment !== null) {
    payload.comment = comment ? "true" : "false";
  }

  return { payload, params };
};

export default {
  getReviewById(id) {
    return apiService.get(endpoints.reviewById(id));
  },
  getReviews(data, isSearch = false) {
    const { payload, params } = prepareRequestData(data);
    const reviewsEndpoint = isSearch
      ? endpoints.reviewsSearch
      : endpoints.reviews;
    return apiService.post(
      reviewsEndpoint,
      { ...pickBy(payload), has_tags: data.has_tags },
      { params }
    );
  },
  reviewsSearch(data) {
    const { payload, params } = prepareRequestData(data);
    return apiService.post(
      endpoints.reviewsSearch,
      { ...pickBy(payload), has_tags: data.has_tags },
      {
        params
      }
    );
  },
  postReply({ id, reply, isAiAssisted }) {
    return apiService.post(endpoints.reviewsReply(id), {
      reply_comment: reply,
      is_ai_assisted: isAiAssisted
    });
  },
  getAiReply({ companyId, gmbReviewId, userId }) {
    const streamInstance = new Stream(
      endpoints.generateReviewReply(companyId, gmbReviewId, userId)
    );
    return streamInstance;
  },
  getAiLimit() {
    return apiService.get(endpoints.aiReplyLimit);
  },
  patchAiReplyConfig(payload) {
    return apiService.patch(endpoints.aiReviewReplyConfig, payload);
  },
  getAiReplyConfig() {
    return apiService.get(endpoints.aiReviewReplyConfig);
  },
  postBulkReply({ ids, reply }) {
    const payload = {
      reply_comment: reply,
      gmb_reviews_ids: ids
    };

    return apiService.post(endpoints.reviewsBulkReply, payload);
  },
  postTemplateBulkReply({ ids, templateIds }) {
    const payload = {
      reply_templates_ids: templateIds,
      gmb_reviews_ids: ids
    };

    return apiService.post(endpoints.reviewsTemplateBulkReply, payload);
  },
  deleteReply({ id }) {
    return apiService.delete(endpoints.reviewsReply(id));
  },
  hideReview(id) {
    return apiService.post(endpoints.reviewVisibility(id));
  },
  unhideReview(id) {
    return apiService.delete(endpoints.reviewVisibility(id));
  },

  getReplyCategories() {
    return apiService.get(endpoints.reviewsReplyCategories);
  },
  postReplyCategory({ name }) {
    const payload = {
      name
    };

    return apiService.post(endpoints.reviewsReplyCategories, payload);
  },
  patchReplyCategory({ name, id }) {
    const payload = {
      name
    };

    return apiService.patch(endpoints.reviewsReplyCategory(id), payload);
  },
  deleteReplyCategory({ id }) {
    return apiService.delete(endpoints.reviewsReplyCategory(id));
  },

  getReplyTemplates({ categoryIds }) {
    const params = {
      category_ids: categoryIds.join(",")
    };

    return apiService.get(endpoints.reviewsReplyTemplates, {
      params: pickBy(params)
    });
  },
  postReplyTemplate({ category, text }) {
    const payload = {
      category: category,
      text
    };

    return apiService.post(endpoints.reviewsReplyTemplates, payload);
  },
  patchReplyTemplate({ text, id }) {
    const payload = {
      text
    };

    return apiService.patch(endpoints.reviewsReplyTemplate(id), payload);
  },
  deleteReplyTemplate({ id }) {
    return apiService.delete(endpoints.reviewsReplyTemplate(id));
  },
  assignTag(reviewId, tagId) {
    return apiService.post(endpoints.reviewsTags(reviewId), { tag: tagId });
  },
  assignCategories(payload) {
    return apiService.patch(endpoints.reviewsBulkTag, payload);
  },
  unassignTag(reviewId, tagId) {
    return apiService.delete(`${endpoints.reviewsTags(reviewId)}${tagId}/`);
  },
  exportReviews(filters) {
    const { payload } = prepareRequestData(filters);
    delete payload.hidden;
    return apiService.post(endpoints.reviewsExport, {
      filters: pickBy(payload)
    });
  },
  postNote(reviewId, text) {
    return apiService.post(endpoints.reviewsNote(reviewId), { text });
  },
  patchNote(reviewId, text) {
    return apiService.patch(endpoints.reviewsNote(reviewId), { text });
  },
  deleteNote(reviewId) {
    return apiService.delete(endpoints.reviewsNote(reviewId));
  },
  patchReviewCategory(reviewId, categoryId, payload) {
    return apiService.patch(
      endpoints.reviewTagCategory(reviewId, categoryId),
      payload
    );
  },

  getGmbCustomerMediaByReviews(reviewIds) {
    return apiService.post(endpoints.gmbCustomerMediaByReviews, {
      review_ids: reviewIds
    });
  }
};
